import {Action} from '@ngrx/store';

export enum ChatActionsType {
    TOGGLE_CHAT = '[Chat] toggleChat',
    SET_ASSIGNERS = '[Chat] setAgemt',
    SET_NOT_VIEWED_MESSAGE = '[Chat] setNotViewedMessage',
    SET_BUBBLE_MESSAGE = '[Chat] setBubbleMessage',
    REMOVE_BUBBLE_MESSAGE = '[Chat] removeBubbleMessage',
    SET_MESSAGE_HISTORY = '[Chat] setMessageHistory',
    SET_MESSAGE = '[Chat] setMessage',
    UPDATE_ASSIGNERS = '[Chat] updataChat'
}

export class ToggleChat implements Action {
    readonly type = ChatActionsType.TOGGLE_CHAT;
    constructor(public payload?: any) {}
}

export class SetAssigners implements Action {
    readonly type = ChatActionsType.SET_ASSIGNERS;
    constructor(public payload: any) {}
}

export class SetBubbleMessage implements Action {
    readonly type = ChatActionsType.SET_BUBBLE_MESSAGE;
    constructor(public payload: any) {}
}

export class RemoveBubbleMessage implements Action {
    readonly type = ChatActionsType.REMOVE_BUBBLE_MESSAGE;
    constructor(public payload: any) {}
}

export class SetMessageHistory implements Action {
    readonly type = ChatActionsType.SET_MESSAGE_HISTORY;
    constructor(public payload: any) {}
}

export class SetMessage implements Action {
    readonly type = ChatActionsType.SET_MESSAGE;
    constructor(public payload: any) {}
}

export class UpdateAssigners implements Action {
    readonly type = ChatActionsType.UPDATE_ASSIGNERS;
    constructor(public payload: any) {}
}

export class SetNotViewedMessage implements Action {
    readonly type = ChatActionsType.SET_NOT_VIEWED_MESSAGE;
    constructor(public payload: any) {}
}

export type ChatActionsUnion = ToggleChat | SetAssigners | SetBubbleMessage | RemoveBubbleMessage  | SetMessage | SetMessageHistory | UpdateAssigners | SetNotViewedMessage;
